"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _LifecycleConfiguration_1 = require("./_LifecycleConfiguration");
exports.PutBucketLifecycleInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        },
        LifecycleConfiguration: {
            shape: _LifecycleConfiguration_1._LifecycleConfiguration,
            locationName: "LifecycleConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "LifecycleConfiguration"
};
//# sourceMappingURL=PutBucketLifecycleInput.js.map